import { Component, HostBinding, OnInit } from '@angular/core';

/**
 * An animated spinner
 */
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
